import { DELTA, OPP, opens, type Dir, type Level, type Tile } from './level';

export class Board {
  tiles: Tile[][];
  readonly rows: number; readonly cols: number;
  moves = 0;
  private done = false;
  constructor(level: Level) {
    this.rows = level.rows; this.cols = level.cols;
    this.tiles = level.tiles.map((r) => r.map((t) => ({ ...t })));
  }
  at(r: number, c: number): Tile | null { return r < 0 || c < 0 || r >= this.rows || c >= this.cols ? null : this.tiles[r]![c]!; }

  /** 밀 수 있는 방향(빈칸 쪽). 고정·빈칸은 못 민다. */
  movableDirs(r: number, c: number): Dir[] {
    const t = this.at(r, c);
    if (!t || t.fixed || t.kind === 'empty' || this.done) return [];
    return (['n', 'e', 's', 'w'] as Dir[]).filter((d) => this.at(r + DELTA[d][0], c + DELTA[d][1])?.kind === 'empty');
  }
  /** 타일을 dir(빈칸 쪽)으로 한 칸. 성공하면 true, moves+1. dir 생략 시 유일한 후보로. */
  slide(r: number, c: number, dir?: Dir): boolean {
    const ds = this.movableDirs(r, c);
    const d = dir ?? (ds.length === 1 ? ds[0] : undefined);
    if (!d || !ds.includes(d)) return false;
    const [dr, dc] = DELTA[d];
    const t = this.tiles[r]![c]!;
    this.tiles[r + dr]![c + dc] = t; this.tiles[r]![c] = { kind: 'empty' };
    this.moves++;
    if (this.path()) this.done = true;
    return true;
  }

  /** start 에서 goal 까지 이어지면 지나는 칸 열, 아니면 null. */
  path(): [number, number][] | null {
    let sr = -1, sc = -1;
    for (let r = 0; r < this.rows; r++) for (let c = 0; c < this.cols; c++) if (this.tiles[r]![c]!.kind === 'start') { sr = r; sc = c; }
    if (sr < 0) return null;
    const start = this.tiles[sr]![sc]!;
    if (!start.open) return null;
    let dir: Dir = start.open, r = sr, c = sc;
    const out: [number, number][] = [[r, c]];
    for (let guard = 0; guard < this.rows * this.cols + 2; guard++) {
      r += DELTA[dir][0]; c += DELTA[dir][1];
      const t = this.at(r, c);
      if (!t) return null;
      const need = OPP[dir];
      const op = opens(t);
      if (!op.includes(need)) return null;
      out.push([r, c]);
      if (t.kind === 'goal') return out;
      // 나가는 방향: 들어온 쪽을 뺀 나머지(교차는 직진)
      const rest = t.kind === 'x' ? [dir] : op.filter((d) => d !== need);
      if (rest.length !== 1) return null;
      dir = rest[0]!;
    }
    return null;
  }
  cleared(): boolean { return this.path() !== null; }
  stars(target?: number): number | undefined {
    if (target === undefined) return undefined;
    return this.moves <= target ? 3 : this.moves <= target + 2 ? 2 : 1;
  }
}
